module.exports = __webpack_public_path__ + "img/春节大促_03.bbfd61d2.png";